var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.706,25.329H52.934c-1.104,0-2,0.896-2,2v4.846H26.294c-1.104,0-2,0.896-2,2v22.853c0,1.104,0.896,2,2,2h14.212v0.799 h-4.19c-1.104,0-2,0.896-2,2s0.896,2,2,2h12.379c1.104,0,2-0.896,2-2s-0.896-2-2-2h-4.189v-0.799h6.427v9.644c0,1.104,0.896,2,2,2 h16.772c1.104,0,2-0.896,2-2V27.329C71.706,26.224,70.811,25.329,69.706,25.329z M28.294,55.027V36.174h22.639v18.853H28.294z  M67.706,66.671H54.934v-9.644V34.174v-4.846h12.772V66.671z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.911,35.276h6.817c1.104,0,2-0.896,2-2s-0.896-2-2-2h-6.817c-1.104,0-2,0.896-2,2S56.807,35.276,57.911,35.276z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.911,40.711h6.817c1.104,0,2-0.896,2-2s-0.896-2-2-2h-6.817c-1.104,0-2,0.896-2,2S56.807,40.711,57.911,40.711z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkstation);
export default __webpack_public_path__ + "static/media/workstation.fe682954730d7fc5a9ed1181b5ce1cff.svg";
export { ForwardRef as ReactComponent };